import Head from 'next/head'

export default function HomePage() {
  return (
    <>
      <Head>
        <title>Cutters waiting screens</title>
        <link rel="icon" href="/favicon.ico" />
      </Head>
    </>
  )
}
